import {API_URL, apiPut} from '../api'

// PUT /v3/admin/feed_template/:id/active — 삭제 없이 노출(활성/비활성) 토글. 비활성은 composer가 뽑지 않음.
export const setFeedTemplateActive = async (id: string, active: boolean) => {
    return await apiPut(API_URL, `admin/feed_template/${id}/active`, {active})
}
